/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_TInputs */

const en_tut_oscari_t = /** @type {(inputs: Tut_Oscari_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finding people and rooms in the office`)
};

const id_tut_oscari_t = /** @type {(inputs: Tut_Oscari_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencari orang dan ruang di kantor`)
};

/**
* | output |
* | --- |
* | "Finding people and rooms in the office" |
*
* @param {Tut_Oscari_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_t = /** @type {((inputs?: Tut_Oscari_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_t(inputs)
	return en_tut_oscari_t(inputs)
});